import { Box, Grommet, Paragraph, Stack, Text } from "grommet";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/HomePage";
import AppHeader from "./components/AppHeader";
import AppFooter from "./components/AppFooter";
// import ServicesPage from "./components/ServicesPage";
import TeamPage from "./pages/TeamPage";
import FaqsPage from "./pages/FaqsPage";
import ProviderPage from "./pages/ProviderPage";
import ResourcesPage from "./pages/ResourcesPage";
// import ServicesPage from "./components/ServicesPage";
import grometTheme from "./grometTheme";
import ContactPage from "./pages/ContactPage";
import CommunityPage from "./pages/CommunityPage";
import colors from "./colors";
import ScheduleAnAppointmentBar from "./components/ScheduleAnAppointmentBar";
import { useState } from "react";
import { AppProvider } from "./stateManager/appContext";
import { useAppContext } from "./stateManager/useAppContext";

const NoMatch = () => {
  return (
    <Box height={{ min: "medium" }}>
      <Text>Nothing to see here!</Text>
      <Paragraph>
        <Link to="/">Go to the home page</Link>
      </Paragraph>
    </Box>
  );
};

const AppRoutes = () => {
  const { siteData } = useAppContext();

  return (
    <Routes>
      <Route index path="/" element={<Home />} />
      <Route path="/team" element={<TeamPage />} />
      {siteData && siteData.providers.map((teamMember, i) => {
        return (
          <Route
            key={"teamMember_"+i}
            path={"/team/" + teamMember.key.current}
            element={<ProviderPage provider={teamMember} />}
          />
        );
      })}
      <Route path="/community" element={<CommunityPage />} />
      <Route path="/faqs" element={<FaqsPage />} />
      <Route path="/resources" element={<ResourcesPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
};

const App = () => {
  const [selectedFont, setSelectedFont] = useState("Noto Serif");

  return (
    <AppProvider>
      <Grommet theme={grometTheme}>
        <span style={{ fontFamily: selectedFont }}>
          <BrowserRouter>
            <Stack anchor="top-left">
              <Box height={{ min: "100vh" }}>
                <AppHeader />
                <Box background={{ color: colors.light2, opacity: "0.4" }}>
                  <AppRoutes />
                </Box>
                <ScheduleAnAppointmentBar />
                <AppFooter />
              </Box>
            </Stack>
          </BrowserRouter>
        </span>
      </Grommet>
    </AppProvider>
  );
};

export default App;
